<template>
<div id="timepicker">
  <v-menu ref="exp_time_menu"
    v-model="timepicker_menu"
    :close-on-content-click="false"
    :disabled="disabled"
    :return-value.sync="timepicker_time"
    transition="scale-transition"
    offset-y
    tile
    @input="$emit('input')"
    content-class="elevation-0 menu"
  >
    <template v-slot:activator="{ on, attrs }"  style="margin-bottom: 20px">
      <v-text-field
        outlined
        class="rounded_8px height_56px"
        v-model="computed_time"
        :placeholder="placeholder"
        persistent-hint
        readonly
        :rules="rules"
        v-bind="attrs"
        v-on="on"
      >
        <div slot="append" v-bind="attrs" v-on="on">
          <v-icon>
            $icon_time
          </v-icon>
        </div>
      </v-text-field>
    </template>
    <v-time-picker
      color="#207EA9"
      flat
      :style="{width: width}"
      format="24hr"
      full-width
      v-model="timepicker_time"
      @click:minute="save_time"
    />
  </v-menu>
</div>
</template>

<script>
import {i18n} from "@/i18n";

export default {
  name: "TimePicker",
  props: [
      'time', 'placeholder', 'width', 'disabled'
  ],
  data: function () {
    return {
      menu_opened: '',
      rules: [
        v => !!v || i18n.t('validation.this_field_is_required'),
      ],
      timepicker_menu: '',
      timepicker_time: this.computed_time,
    }
  },
  methods: {
    save_time: function () {
      this.$refs.exp_time_menu.save(this.timepicker_time)
      this.$emit('save_time', {time: this.timepicker_time})
    }
  },
  computed: {
    computed_time: function () {
      // console.log(`TIME TO TIMEPICKER: ${this.timepicker_time}`)
      let loading_text = i18n.t('general.loading') + '...'
      return this.time === 'Invalid date' ? loading_text : this.time
    }
  }
}
</script>

<style lang="scss">
.v-menu__content {
  box-shadow: none;
}
.v-time-picker-title {
  justify-content: center !important;
}
.menu {
  margin-top: 10px;
  contain: initial;
  overflow: visible;
}
.menu::before {
  right: 10px;
  top: -10px;
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #207ea9 transparent;
}

</style>